import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Site } from '@classes/site';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-pre-billing',
  templateUrl: './pre-billing.component.html',
  styleUrls: ['./pre-billing.component.scss']
})
export class PreBillingComponent extends DatatableBaseComponent implements OnInit{
  sites: Site[];
  siteForm = this._fb.group({
    site: [null, [Validators.required]],
  });

  siteSelected: boolean = false ;

  constructor(
    protected uiSrv: UiService,
    private _route: ActivatedRoute,
    private _fb: FormBuilder,
  ){
    super(uiSrv) ;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this._loadDatas();
  }

  private _loadDatas(): void {
    this._route.data
      .subscribe((datas: { sites: Site[] }) => {
        this.sites = datas.sites;
        this._initFormSubscriptions();
        this.isLoading = false;
      });
  }

  private _initFormSubscriptions(): void{
    this.addSubscription(
      this.siteForm.get("site").valueChanges.subscribe(() => {
        this.siteSelected = false ;
      }) 
    );
  }

  public getControl(control: string): UntypedFormControl {
    return this.siteForm.get(control) as UntypedFormControl;
  }

  public onSubmitSiteForm(){
      this.siteSelected = this.siteForm && this.siteForm.valid ;
  }

  public getSelectedSite(): Site | null{
    return this.siteForm?.get("site")?.value ;
  }
}
